import { IHavePath } from "../types/IHavePath";

export const LogoutMeta: IHavePath = { path: "/logout" };
